import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantDownlines = (id) => useQuery({ queryKey: [`${id}-downlines`], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/downlines`)
    return callback?.data
}})

export default useConsultantDownlines